var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoticeFillBlue4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Megaphone_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.2555 4.68514C18.307 4.8585 18.3332 5.03839 18.3332 5.21924V14.7821C18.3332 15.8176 17.4937 16.6571 16.4582 16.6571C16.2773 16.6571 16.0973 16.6309 15.9239 16.5794L11.329 15.213C10.7813 16.3339 9.63187 17.0827 8.33317 17.0827C6.54801 17.0827 5.09061 15.6794 5.00392 13.9157L4.99984 13.7494L4.999 13.3321L3.00726 12.7398C2.21189 12.5034 1.6665 11.7723 1.6665 10.9426V9.05763C1.6665 8.22781 2.21196 7.49669 3.0074 7.26031L15.9241 3.42192C16.9167 3.12695 17.9605 3.69251 18.2555 4.68514ZM6.249 13.7037L6.24984 13.7494C6.24984 14.9 7.18258 15.8327 8.33317 15.8327C9.07087 15.8327 9.73179 15.4459 10.103 14.8498L6.249 13.7037Z",
    fill: "#166DD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoticeFillBlue4);
export default __webpack_public_path__ + "static/media/icon-notice-fill-blue4.46fe48a72a52c7e5c5f4813282ce1924.svg";
export { ForwardRef as ReactComponent };